import { render } from "./LeftNav.vue?vue&type=template&id=4642f605"
import script from "./LeftNav.vue?vue&type=script&lang=js"
export * from "./LeftNav.vue?vue&type=script&lang=js"

import "./LeftNav.vue?vue&type=style&index=0&id=4642f605&lang=less"

import exportComponent from "/builds/web-nfb/collection/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__